<template>
  <v-dialog
    v-model="editPriceDialog"
    no-click-animation
    overlay-color="rgba(39, 50, 64)"
    overlay-opacity="0.6"
    :fullscreen="$vuetify.breakpoint.xs ? true : false"
    persistent
    width="500"
    :transition="false"
  >
    <v-card>
      <v-card-title class="pl-5">
        {{ $t('modules.ito.changePriceModal.title') }}
      </v-card-title>
      <v-card-text>
        <v-layout
          wrap
        >
          <v-flex
            xs12
            mt-2
          >
            <span>
              {{ $t('modules.ito.currentPrice') }}:
              <b>{{ ito.current_price }} {{ getMainCurrency }}</b>
            </span>
          </v-flex>
          <v-flex
            v-if="ito.next_price"
            xs12
            mt-2
          >
            <span>
              {{ $t('modules.ito.nextPrice') }}:
              <b>{{ ito.next_price }} {{ getMainCurrency }}</b>
            </span>
          </v-flex>
          <v-flex
            xs12
            mt-2
          >
            <v-text-field
              v-model.trim="form.price"
              :error-messages="CurrentPriceError"
              :suffix="getMainCurrency"
              :label="$t('modules.ito.changePriceModal.newPrice') + '*'"
              @input="$v.form.price.$touch()"
              @blur="$v.form.price.$touch()"
            />
          </v-flex>
          <v-flex
            xs12
            mt-2
          >
            <v-text-field
              v-model.trim="form.next_price"
              :error-messages="NextPriceError"
              :suffix="getMainCurrency"
              :label="$t('modules.ito.nextPrice')"
              @input="$v.form.next_price.$touch()"
              @blur="$v.form.next_price.$touch()"
            />
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          outlined
          @click="editPriceDialog = false"
        >
          {{ $t("modules.closeButton") }}
        </v-btn>
        <v-btn
          class="primary"
          :disabled="loading || $v.$invalid"
          :loading="loading"
          @click="save()"
        >
          {{ $t("modules.ito.changePriceModal.changeButton") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import ITO_CHANGE_PRICE_MUTATION from "@/graphql/mutations/modules/ItoChangePrice.gql";

import { validationMixin } from "vuelidate";
import {
  decimal,
  required,
  minValue,
  maxValue
} from "vuelidate/lib/validators";
import {mapGetters} from "vuex";

export default {
  name: "EditCurrentPrice",
  mixins: [validationMixin],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    ito: {
      type: Object,
      default: null
    },
    whitelabelUuid: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      loading: false,
      form: {
        price: "",
        next_price: ""
      },
    }
  },
  validations() {
    return {
      form: {
        price: {
          required,
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(999999999)
        },
        next_price: {
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(999999999)
        }
      }
    };
  },
  computed: {
    ...mapGetters("whitelabel", ["getMainCurrency"]),
    editPriceDialog: {
      get() {
        return this.showDialog;
      },
      set(val) {
        this.$emit("closeEditPriceDialog", val);
      }
    },
    CurrentPriceError(){
      const errors = [];
      if (!this.$v.form.price.$dirty) return errors;
      !this.$v.form.price.required && errors.push(this.$t("globals.reqField"));
      !this.$v.form.price.decimal &&
        errors.push(this.$t("globals.numberField"));
      !this.$v.form.price.minValue &&
        errors.push(this.$t("whitelabel.minValueError", {char: this.$v.form.price.$params.minValue.min}));
      !this.$v.form.price.maxValue &&
        errors.push(this.$t("whitelabel.maxValueError", {char: this.$v.form.price.$params.maxValue.max}));
      return errors;
    },
    NextPriceError(){
      const errors = [];
      if (!this.$v.form.next_price.$dirty) return errors;
      !this.$v.form.next_price.decimal &&
        errors.push(this.$t("globals.numberField"));
      !this.$v.form.next_price.minValue &&
        errors.push(this.$t("whitelabel.minValueError", {char: this.$v.form.next_price.$params.minValue.min}));
      !this.$v.form.next_price.maxValue &&
        errors.push(this.$t("whitelabel.maxValueError", {char: this.$v.form.next_price.$params.maxValue.max}));
      return errors;
    },
  },
  methods: {
    save() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.loading = true;
      const params = {
        whitelabel_uuid: this.whitelabelUuid,
        ito_uuid: this.ito.uuid,
        price: +this.form.price,
        next_price: this.form.next_price ? +this.form.next_price : null
      }

      this.$apollo
        .mutate({
          mutation: ITO_CHANGE_PRICE_MUTATION,
          variables: params
        })
        .then(data => {
          this.$store.commit('app/setNotifier', this.$t('globals.success'));
          this.editPriceDialog = true;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          if (error.graphQLErrors[0].extensions.category == 'authorization' && error.graphQLErrors[0].message === "This action is unauthorized.") {
            this.$store.commit("app/setShowPermission");
            return;
          }
          this.errorHandler(error)
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
